import {styled, Typography} from "@mui/material";

const AppLinkParagraph = styled(Typography)`
  cursor: pointer;
  color: #06326E;
`;

export default AppLinkParagraph;
